export default __webpack_public_path__ + "static/media/search.4ef214cf.svg";